import { useContext } from 'react'
import { context } from '../context'

export function useInstance<T>(name: string): T {
  const di = useContext(context)
  return di.find<T>(name)
}
